var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.029 55L60 29.5.029 4 0 23.833 42.857 29.5 0 35.167.029 55z",
    fill: "#163C67"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDYwIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC4wMjg1NzE0IDU1TDYwIDI5LjVMMC4wMjg1NzE0IDRMMCAyMy44MzMzTDQyLjg1NzEgMjkuNUwwIDM1LjE2NjdMMC4wMjg1NzE0IDU1WiIgZmlsbD0iIzE2M0M2NyIvPgo8L3N2Zz4K";
export { SvgSend as ReactComponent };